import React from 'react'
import NoContent from "./NoContent";
import HomePage from "@system/config/home-page";
import CommonHomePageContent from "src/pages/HomePageContent/Common";
import System from "../../helper/system";
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import AxiosIndicatorRunTimeLoader from '../AxiosIndicatorRunTimeLoader';

let c = System.getParams();


const Articles = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { articlesList, searchText, apiCall } = props;

    const typeHeadSearchEvent = (obj) => {
        HelperAnalyticsEvent.typeHeadSearchEvent(searchText, "Articles", obj?.name, obj?.url)
    }

    return (
        <>
            <div className="search-item-title text-uppercase">RECOMMENDED Articles</div>
            {__check(['UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL']).status && !apiCall.Article ?
                <AxiosIndicatorRunTimeLoader />
                : <>
                    {Object.keys(articlesList).length > 0 ?
                        <>
                            <div className="search-product-list">
                                {Object.keys(articlesList).length > 0 && Object.entries(articlesList).map((v, i) => (
                                    <React.Fragment key={i}>
                                        {
                                            i < 5 &&

                                            <div className="search-product-list-item">
                                                <div className='search-product-list-item-info'>
                                                    <div className="documents-date">{v[1].date}</div>
                                                    <a onClick={() => typeHeadSearchEvent(v[1])} href={v[1]?.url} className="cursor-pointer">
                                                        <div className="search-product-list-info-title">{v[1].name}</div>
                                                    </a>
                                                    <div className="search-product-list-info-desc">{v[1].shortDescription}</div>
                                                </div>
                                            </div>
                                        }
                                    </React.Fragment>
                                ))}
                            </div>
                            <a href={HomePage.makeHomeTabsListRouteURL(CommonHomePageContent.chain_HomeTabList.CNT.param_value) + "&__c_HomePageContent=ALCT&__c_HomePageContentTabList=ACL&search=" + searchText + '&viewAll=true'}
                                className="text-center mt-auto pb-3">
                                <div className="bs5 btn btn-sm btn-primary">VIEW ALL ARTICLE RESULTS</div>
                            </a>
                        </> : <NoContent />
                    }
                </>
            }
        </>
    )
}

export default Articles